import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { EsitoMeritoForm } from '../../../form/esito-merito-form';

import { DettaglioEsito } from '../../../models/dettaglio-esito';
import { Esito } from '../../../models/esito';

@Component({
    selector: 'div [esito-merito-form-add]',
  templateUrl: '../../../form/esiti-merito-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class EsitiMeritoAddComponent extends EsitoMeritoForm implements OnInit {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  idSezioneEsiti: string;
  idEsito: string;
  esito: Esito;
  updateUrl: string;
  modalNotifyService: ModalNotifyService;
  urlSezioneEsiti: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(ModalNotifyService) modalNotifyService) {
        super(helpers, operationService, campiForm);
        this.modalNotifyService = modalNotifyService;
  }

  ngOnInit() {
    this.setTitle('Aggiungi Dettaglio esito');
    this.isInserimento(true);
  }

  inizializza(updateUrl: string, esito: Esito, urlSezioneEsiti: string, idSezioneEsiti: string, urlSezioneControparti: string, idSezioneControparti: string, urlSezioneClassificazioni: string, idSezioneClassificazione: string, idPratica: string) {
    this.idEsito = esito.id;
    this.urlSezioneEsiti = urlSezioneEsiti;
    this.esito = esito;
    this.idSezioneEsiti = idSezioneEsiti;
    this.updateUrl = updateUrl;
    this.populateSelect(urlSezioneControparti, idSezioneControparti, urlSezioneClassificazioni, idSezioneClassificazione);
    this.readClassificazioni(idPratica);
    this.createForm();
  }

  getMeritoEsito(): DettaglioEsito {
    return new DettaglioEsito();
  }

  getRequest(dettagliEsito: DettaglioEsito[]) {
    this.operationsService.addDettagliEsito(this.updateUrl, this.esito, dettagliEsito).subscribe(response => this.returnSetSezEsitiOrdinario());
  }

  returnSetSezEsitiOrdinario() {
    this.operationsService.readSezione(this.urlSezioneEsiti, this.idSezioneEsiti).subscribe(response=>{
        this.onReturn.emit(response.sezione);
    })
  }
}
